import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const ImgText = ({ blok }) => (
  <div className="wrap">
    <div
      className="imagetext-wrap flex justify-between inner-wrap"
      {...storyblokEditable(blok)}
    >
      <div className="imagetext-content">
        <h2 className="text-2xl">{blok.subheadlineleft}</h2>
        <div className="img-box">
          <Link href={blok.link1} >
            <img src={blok.imageleft.filename} alt={blok.imageleft.alt} />
          </Link>
          <div className="find-more-btn hide">Klicken um mehr zu erfahren</div>
        </div>
        <p className="">{blok.textleft}</p>
      </div>
      <div className="imagetext-content ml-16">
        <h2 className="text-2xl">{blok.subheadlineright}</h2>
        <div className="img-box">
          <Link href={blok.link2} >
            <img src={blok.imageright.filename} alt={blok.imageright.alt} />
          </Link>
          <div className="find-more-btn hide">Klicken um mehr zu erfahren</div>
        </div>
        <p className="">{blok.textright}</p>
      </div>
    </div>
  </div>
);

export default ImgText;
